export const ImageSources = {
    dentalMediaLogo: '/images/dental-media-logo.svg',
}
